import * as yup from 'yup';
import { CompanyTeamNotesField } from './CompanyTeamNotesField';

export const validationSchema = yup.object().shape({
  [CompanyTeamNotesField.Message]: yup
    .string()
    .required()
    .label('Comment'),
});
